import React from "react";

// The focus-driven backdrop lives in FocusBackground (mounted once in Home);
// the hero just sits on top of it and inherits the theme's text tokens.
export default function Landing() {
  return (
    <section id="landing" className="section landing">
      <div className="landing-content">
        <h1>Oliver Bujdoš</h1>
        <p className="landing-subtitle">Software Developer</p>
      </div>
    </section>
  );
}
